import { DialogTitleClassKey } from '@material-ui/core/DialogTitle';

const MuiDialogTitle = (): Partial<Record<DialogTitleClassKey, unknown>> => ({
    root: {
        minHeight: 14,
    },
});

export default MuiDialogTitle;
